import { createContext } from 'react'
import type { LocationSearchParams } from '../../hooks/useLocatiomSearchParams'

interface SearchFiltersContextValue {
  localFilters: LocationSearchParams
  filters: LocationSearchParams
  updateLocalFilters: (updates: Partial<LocationSearchParams>, commit?: boolean) => void
  commitFilters: () => void
}

export const SearchFiltersContext = createContext<SearchFiltersContextValue | null>(null)
